import { type BonusType, BonusTypeMode, formatDateShort, parseDurationString, toDurationString } from "@pentacode/core";
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import "../../../elements/popover";
import { shared } from "../../../styles";

@customElement("ptc-bonus-type-item")
export class BonusTypeEl extends LitElement {
    @property({ attribute: false })
    bonusType: BonusType;

    private get _intervals(): [number, number][] {
        return (
            this.bonusType?.intervals.map(([start, end]) => [parseDurationString(start), parseDurationString(end)]) ||
            []
        );
    }

    static styles = [
        shared,
        css`
            :host {
                display: block;
                padding: 0.8em;
            }
        `,
    ];

    render() {
        const bonusType = this.bonusType;
        return html`
            <div class="larger bottom-margined">
                ${bonusType.name || html`<span class="subtle">Neue Zuschlagsart</span>`}
            </div>
            <div class="smaller pills">
                ${bonusType.mode === BonusTypeMode.Daily
                    ? html`<div class="pill"><ptc-ui-icon name="icon.object.history"></ptc-ui-icon> Täglich</div>`
                    : bonusType.mode === BonusTypeMode.WeekDays
                      ? bonusType.weekDays?.map(
                            (day) =>
                                html`<div class="pill">
                                    <ptc-ui-icon name="icon.object.date"></ptc-ui-icon> ${[
                                        "So",
                                        "Mo",
                                        "Di",
                                        "Mi",
                                        "Do",
                                        "Fr",
                                        "Sa",
                                    ][day]}
                                </div>`
                        )
                      : bonusType.mode === BonusTypeMode.Holidays
                        ? html`<div class="pill">
                              <ptc-ui-icon name="icon.event.holiday"></ptc-ui-icon> Gesetzliche Feiertage
                          </div>`
                        : bonusType.mode === BonusTypeMode.Date
                          ? html`<div class="pill">
                                <ptc-ui-icon name="icon.object.date"></ptc-ui-icon> ${formatDateShort(
                                    "2001-" + bonusType.date!
                                )}
                            </div>`
                          : ""}
                ${this._intervals.map(
                    ([start, end]) =>
                        html`<div class="pill">
                            <ptc-ui-icon name="icon.object.time"></ptc-ui-icon> ${toDurationString(start % 24)}
                            ${start >= 24 ? "(Folgetag)" : ""} - ${toDurationString(end % 24)}
                            ${end >= 24 ? "(Folgetag)" : ""}
                        </div>`
                )}
                ${bonusType.shiftMustStartBefore
                    ? html`
                          <div class="pill" title="Schichtbeginn vor">
                              <ptc-ui-icon name="icon.action.start-shift"></ptc-ui-icon>
                              ${bonusType.shiftMustStartBefore.slice(0, 5)}
                          </div>
                      `
                    : ""}
            </div>
        `;
    }
}
